import { EnterHttpError, type ApiHomeLoginResult } from '@enter/api';
import { isBootstrapDependencyHTTPFailure } from '@/lib/bootstrap-diagnostics/bootstrap-diagnostics';

/** 编号来自原生资料请求；首轮钟为认证 scope 挂载，显式失败重试钟为新请求。 */
interface StartedAttempt {
    readonly id: string;
    readonly startedAtMS: number;
    readonly startedMonoMS: number;
}
export type UserInfoLoginAttempt = StartedAttempt & (
    | { readonly phase: 'loading' | 'ready' }
    | { readonly phase: 'failed'; readonly result: ApiHomeLoginResult; readonly finishedMonoMS: number }
);

export function classifyUserInfoFailure(error: unknown): ApiHomeLoginResult {
    if (error instanceof EnterHttpError && error.status === 401) {
        const body = error.responseBody;
        if (body && typeof body === 'object' && 'code' in body && body.code === 401 &&
            'message' in body && body.message === 'user_inactive') {
            return { outcome: 'normal_rejection', reason: 'access_rejected' };
        }
    }
    if (isBootstrapDependencyHTTPFailure(error)) {
        return { outcome: 'technical_failure', reason: 'user_info_http_failure' };
    }
    return { outcome: 'unknown', reason: 'bootstrap_unverified' };
}
